import React, { Suspense, Fragment } from 'react'
import { Switch, Route } from 'react-router-dom'
import Bar from './components/Loader/Bar'
// import ErrorBoundary from './ErroBoundary'

export const renderRoutes = (routes = []) => (
  <Suspense fallback={<Bar />}>
    <Switch>
      {routes.map((route, i) => {
        const Guard = route.guard || Fragment
        const Layout = route.layout || Fragment
        const Component = route.component

        return (
          <Route
            // eslint-disable-next-line react/no-array-index-key
            key={i}
            path={route.path}
            exact={route.exact}
            render={(props) => (
              <Guard key={i + route.path}>
                <Layout key={i + route.path}>
                  {/* <ErrorBoundary> */}
                  {route.routes ? (
                    renderRoutes(route.routes)
                  ) : (
                    <Component {...props} />
                  )}
                  {/* </ErrorBoundary> */}
                </Layout>
              </Guard>
            )}
          />
        )
      })}
    </Switch>
  </Suspense>
)

